module.exports = __webpack_public_path__ + "img/empowered-hand.e313d89b.svg";